// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__1z59W","p":"styles_p__y9ZUZ"};